exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2TyOY6BIr7XXDZM8n7GlV{max-width:150px}._1-bC9nVIUmy0rsQSrHwHzo{border:2px solid #e0e0e0;border-radius:50%;display:block;margin:0 auto;background:#fff;object-fit:cover}._36fSWGeCPpT0umY6NfpEbT{max-width:500px}._36fSWGeCPpT0umY6NfpEbT *>button._38rMHEaUPCt4NnZJpDJdij{display:flex;align-items:center;justify-content:center;padding:2px 0px;height:152px;flex-basis:150px;border-radius:0px}._36fSWGeCPpT0umY6NfpEbT *>button._3RKZ-6B1IoTXa66QVnRuAA{padding:5px 0px}\n", ""]);

// Exports
exports.locals = {
	"maxWidth": "_2TyOY6BIr7XXDZM8n7GlV",
	"plusIcon": "_1-bC9nVIUmy0rsQSrHwHzo",
	"badges": "_36fSWGeCPpT0umY6NfpEbT",
	"badgeButton": "_38rMHEaUPCt4NnZJpDJdij",
	"selectedBadgeButton": "_3RKZ-6B1IoTXa66QVnRuAA"
};